import { throwError as observableThrowError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { Roster } from "../models/roster.model";
import { LmApiService } from "./lm-api.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./lm-api.service";
var TeacherAssignService = /** @class */ (function () {
    function TeacherAssignService(http, lmApi) {
        this.http = http;
        this.lmApi = lmApi;
    }
    TeacherAssignService.prototype.getRosterSet = function () {
        return this.lmApi.get("/tools/rosters/api/v2/rosters/rosterset/").pipe(catchError(function (error) { return observableThrowError(error); }), map(function (data) {
            var rosters = [];
            if (data && data.rosters) {
                data.rosters.map(function (roster) {
                    rosters.push(new Roster(roster));
                });
            }
            return rosters;
        }));
    };
    TeacherAssignService.prototype.saveAssignment = function (assignCode, rosters) {
        if (assignCode === void 0) { assignCode = ""; }
        if (rosters === void 0) { rosters = []; }
        var data = this.prepareRosterForPost(assignCode, rosters);
        return this.lmApi.post("/tools/rosters/api/v2/roster_assignments/assign-res-rosters/", data);
    };
    TeacherAssignService.prototype.prepareRosterForPost = function (assignCode, rosters) {
        if (assignCode === void 0) { assignCode = ""; }
        if (rosters === void 0) { rosters = []; }
        var postReadyRosters = [];
        var assignableRosters = rosters.filter(function (roster) {
            return roster.selected;
        });
        assignableRosters.forEach(function (roster) {
            var rosterObj = {
                rosterId: roster.rosterId,
                studentIds: [],
            };
            roster.students.forEach(function (student) {
                if (student.selected) {
                    rosterObj.studentIds.push(student.studentRosterId);
                }
            });
            postReadyRosters.push(rosterObj);
        });
        return {
            activityCode: assignCode,
            students: postReadyRosters,
        };
    };
    TeacherAssignService.ngInjectableDef = i0.defineInjectable({ factory: function TeacherAssignService_Factory() { return new TeacherAssignService(i0.inject(i1.HttpClient), i0.inject(i2.LmApiService)); }, token: TeacherAssignService, providedIn: "root" });
    return TeacherAssignService;
}());
export { TeacherAssignService };
